module.exports = __webpack_public_path__ + "media/images/users/maigo-d79d58fa09a871d1c4e62d1685c5fb76.png";